import { get, post } from "./request";
import request from "./request";

/**
 * 支付方式接口（API 文档第 10 节 /console/payment-methods）。
 */

export interface PaymentMethod {
  id: string;
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
  isDefault: boolean;
}

/** GET /payment-methods */
export function getPaymentMethods(): Promise<PaymentMethod[]> {
  return get<PaymentMethod[]>("/payment-methods");
}

/** POST /payment-methods/setup-intent — 创建 SetupIntent，返回 clientSecret */
export function createSetupIntent(): Promise<{ clientSecret: string }> {
  return post<{ clientSecret: string }>("/payment-methods/setup-intent");
}

/** DELETE /payment-methods/{id} */
export function deletePaymentMethod(id: string): Promise<{ message: string }> {
  return request.delete(`/payment-methods/${id}`) as unknown as Promise<{
    message: string;
  }>;
}

/** PUT /payment-methods/{id}/default */
export function setDefaultPaymentMethod(
  id: string
): Promise<{ message: string }> {
  return request.put(`/payment-methods/${id}/default`) as unknown as Promise<{
    message: string;
  }>;
}
